<template>
  <div>
    <div>
      <van-search
        v-model="searchValue"
        :placeholder="placeholderText"
        left-icon
        :show-action="cancelShow"
        @search="onSearch"
        @cancel="onCancel"
        @focus="onFocus"
        class="searchBox"
        :action-text="$t('取消')"
      >
        <!-- right-icon="search" -->
        <div
          name="search"
          slot="right-icon"
          @click="onSearch"
          class="search-icon"
        ></div>
      </van-search>
    </div>
  </div>
</template>

<script>
import getTranslation from '@/locale/getTranslation'
export default {
  data() {
    return {
      searchValue: '',
      placeholderText: '',
      cancelShow: false
    }
  },
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  watch: {
    value(newVal) {
      this.searchValue = newVal
      if (newVal == '') {
        this.cancelShow = false
      } else {
        this.cancelShow = true
      }
    },
    placeholder(newVal) {
      this.placeholderText = newVal
    }
  },
  mounted() {
    this.placeholderText = this.placeholder
    this.searchValue = this.value
  },
  methods: {
    onFocus() {
      this.cancelShow = true
      this.$emit('focus')
    },
    onSearch() {
      if (this.searchValue.match(/^[ ]*$/)) {
        this.$toast({
          message: getTranslation('搜索内容不能为空')
        })
        this.searchValue = '' //清空输入框
        return
      }
      let patrn = /^[`~!@#$%^&*()_\-+=<>?:"{}|,.\\/;'\\[\]·~！ @#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]*$/im
      if (patrn.test(this.searchValue)) {
        this.$toast({
          message: getTranslation('搜索内容不能全是特殊字符')
        })
        return
      }

      this.$emit('search', this.searchValue)
    },
    onCancel() {
      this.cancelShow = false
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="scss" scoped>
.search-icon {
  width: 0.4rem;
  height: 100%;
  margin-left: 12px;
  position: absolute;
  right: 0.15rem;
  top: 0;
  background: url('../../../assets/img-m/search-icon.png') no-repeat center;
  background-size: 0.3rem;
}
/deep/.van-search {
  background: none;
}
/deep/.van-field__right-icon {
  padding: 0 0.44rem;
}
/deep/.van-search__content {
  width: 6.9rem;
  margin: 0 auto;
  border-radius: 0.35rem;
}
/deep/.van-search__action {
  color: #fff;
}
/deep/.van-field__control[type='search'] {
  padding-left: 0.2rem;
  font-size: 0.28rem;
}
</style>
